/*
 * To use: Initialize the modal in the parent component using JQuery. See collaborators-modal.component.ts for example.
 */

import { Component, OnInit, Input } from '@angular/core';

type ModalSize = 'mini' | 'tiny' | 'small' | 'medium' | 'large' | 'fullscreen';

@Component({
    selector: 'zoom-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnInit {
    @Input() size: ModalSize;
    @Input() id: string;
    @Input() imageFileName: string;
    @Input() headerText: string;
    @Input() confirmText: string;
    @Input() shouldDisableConfirm = false;
    @Input() backgroundColour = 'blue';

    constructor() {}

    ngOnInit() {}
}
